import App from 'App';
import DigitalGiftCardsPage from 'pages/DigitalGiftCards';
import ErrorPage from 'pages/Error';
import LandingPage from 'pages/LandingPage';
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import DefaultLayout from 'shared/layout/DefaultLayout';

export const routeBuilder = {
  root: () => '/',
  error: (code?: number) => `/error${code ? `?code=${code}` : ''}`,
  giftCards: () => '/gift-cards',
};

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route element={<DefaultLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="error" element={<ErrorPage />} />
        <Route path="gift-cards" element={<DigitalGiftCardsPage />} />
        <Route path="*" element={<Navigate to="/error?code=404" />} />
      </Route>
    </Route>
  )
);
